export const firstData = {
  xAxis: '销量',
  yAxis: '年份',
  array: [
    [2012, 975],
    [2013, 375],
    [2014, 425],
    [2015, 960],
    [2016, 700],
    [2017, 800],
    [2018, 975],
    [2019, 775],
  ],
}
export const secondData = {
  xAxis: '销量',
  yAxis: '品类',
  array: [
    ['衬衫', 5],
    ['羊毛衫', 20],
    ['雪纺衫', 36],
    ['裤子', 10],
    ['高跟鞋', 10],
    ['袜子', 20],
  ],
}

export const thirdData = {
  xAxis: '销量',
  yAxis: '品类',
  array: [
    ['羊毛衫', 20],
    ['裤子', 10],
    ['袜子', 390],
    ['雪纺衫', 36],
    ['高跟鞋', 10],
    ['衬衫', 5],
  ],
}

export default function getChartData(option) {
  return { 1: firstData, 2: secondData, 3: thirdData }[option]
}
